import React from 'react';
import { Content } from './shared';

const UnitedFluShot = () => (
  <Content>
    The following pharmacies and clinics offer free flu shots:
    <ul>
      <li>Albertsons</li>

      <li>Albertsons Pharmacy</li>

      <li>CVS Pharmacy</li>

      <li>Harris Teeter</li>

      <li>H-E-B</li>

      <li>Hy-Vee</li>

      <li>Kmart</li>

      <li>The Little Clinic</li>

      <li>The Kroger Company</li>

      <li>Meijer</li>

      <li>MinuteClinic</li>

      <li>Publix</li>

      <li>RediClinic</li>

      <li>Safeway Stores</li>

      <li>United Supermarkets</li>

      <li>Walgreens</li>

      <li>Walgreens Healthcare Clinic</li>

      <li>Walmart</li>

      <li>Sam's Club</li>
    </ul>
    Note: Be sure to confirm with the provider that they accept your medical plan before receiving
    services.
  </Content>
);

export default UnitedFluShot;
